import { Stack, Typography } from '@mui/material'
import { Placeholder } from 'api'
import { SettingsItem } from 'components/global'
import { Dialog } from 'elements/feedback'
import { useBoolean } from 'lib/hooks'
import { useTranslation } from 'react-i18next'

import { EditPlaceholdersForm } from './edit-placeholders-form'

type ProjectPlaceholdersBlockProps = {
  projectId: string
  placeholders: Placeholder
}

export const ProjectPlaceholdersBlock = ({
  projectId,
  placeholders,
}: ProjectPlaceholdersBlockProps) => {
  const { t } = useTranslation()

  const isOpen = useBoolean()

  return (
    <>
      <SettingsItem
        title={t('projects.terms.placeholders.export_import_placeholders')}
        onClick={isOpen.setTrue}
        tooltipConfig={{
          text: t('projects.settings.placeholders.info_helper_tooltip_text'),
          title: t('projects.settings.placeholders.info_helper_tooltip_title'),
        }}
      >
        <Stack>
          <Typography variant="caption2">{`${t(
            'projects.terms.placeholders.general_placeholder',
          )}: ${placeholders.base}`}</Typography>

          <Typography variant="caption2">
            {`${t('projects.terms.placeholders.named_placeholder')}: ${
              placeholders.namedLeft
            } ${placeholders.namedRight}`}
          </Typography>
        </Stack>
      </SettingsItem>

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse}>
        <EditPlaceholdersForm
          projectId={projectId}
          placeholders={placeholders}
          onClose={isOpen.setFalse}
        />
      </Dialog>
    </>
  )
}
